import { X, Check, TrendingDown, TrendingUp } from "lucide-react";

const BANK = [
    "Hidden FX spreads (2–5%)",
    "Slow settlements (3–5 days)",
    "Manual compliance paperwork",
    "Poor SME experience",
    "Fragmented across portals",
];

const TRUO = [
    "Transparent interbank pricing",
    "Fast settlements (<24–48 hrs)",
    "Automated compliance & filings",
    "Real-time payment tracking",
    "Unified, single platform",
];

export default function ProblemSolution() {
    return (
        <section className="bg-zinc-50 py-24 md:py-32 px-4 md:px-8" data-testid="problem-solution-section">
            <div className="mx-auto max-w-7xl">
                <div className="max-w-2xl">
                    <span className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-700">
                        The TruoPay difference
                    </span>
                    <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-zinc-950">
                        Banks were built for paper. TruoPay is built for the API era.
                    </h2>
                </div>

                <div className="mt-12 grid md:grid-cols-2 gap-6">
                    {/* Banks */}
                    <div className="relative rounded-3xl border border-zinc-200 bg-white p-7 sm:p-9 overflow-hidden">
                        <div
                            aria-hidden
                            className="pointer-events-none absolute -top-20 -right-16 h-56 w-56 rounded-full bg-red-100/70 blur-2xl"
                        />
                        <div className="relative">
                            <div className="flex items-center justify-between">
                                <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-700">
                                    Traditional Banks
                                </div>
                                <TrendingDown className="h-5 w-5 text-red-500" />
                            </div>
                            <div className="mt-5">
                                <div className="font-heading text-4xl sm:text-5xl font-extrabold text-zinc-950 font-mono">
                                    ~2.5–5%
                                </div>
                                <div className="text-sm text-zinc-500 mt-1">
                                    average bank FX markup
                                </div>
                            </div>
                            <ul className="mt-8 space-y-3">
                                {BANK.map((b) => (
                                    <li key={b} className="flex items-start gap-3 text-zinc-700">
                                        <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-50 ring-1 ring-red-200">
                                            <X className="h-3 w-3 text-red-600" />
                                        </span>
                                        <span className="text-sm sm:text-base">{b}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* TruoPay */}
                    <div className="relative rounded-3xl bg-gradient-to-br from-[#04110D] via-[#063a2c] to-[#04110D] p-7 sm:p-9 text-white overflow-hidden glow-emerald">
                        <div
                            aria-hidden
                            className="pointer-events-none absolute -top-24 -right-16 h-64 w-64 rounded-full bg-emerald-500/25 blur-3xl"
                        />
                        <div className="relative">
                            <div className="flex items-center justify-between">
                                <div className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-300">
                                    TruoPay
                                </div>
                                <TrendingUp className="h-5 w-5 text-emerald-300" />
                            </div>
                            <div className="mt-5">
                                <div className="font-heading text-4xl sm:text-5xl font-extrabold font-mono text-white">
                                    0.3–0.5%
                                </div>
                                <div className="text-sm text-zinc-400 mt-1">
                                    transparent TruoPay margin
                                </div>
                            </div>
                            <ul className="mt-8 space-y-3">
                                {TRUO.map((b) => (
                                    <li key={b} className="flex items-start gap-3 text-zinc-200">
                                        <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-emerald-500/20 ring-1 ring-emerald-400/40">
                                            <Check className="h-3 w-3 text-emerald-300" />
                                        </span>
                                        <span className="text-sm sm:text-base">{b}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
